import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzMcParameterDetailSelect from "src/components/shared-components/ByzMcParameterDetailSelect";
import { McParameterDetailResponseDto } from "src/api/references/referenceServicesDtos";

interface AssessmentFieldProps {
    label: string;
    mcpId: number;
    value: McParameterDetailResponseDto | null;
    onChange: (newValue: McParameterDetailResponseDto | null) => void;
    getMcpParameterDetails: (mcpId: number) => McParameterDetailResponseDto[];
    cacheLoaded: boolean;
    noBorder?: boolean;
}

export const AssessmentField = ({
    label,
    mcpId,
    value,
    onChange,
    getMcpParameterDetails,
    cacheLoaded,
    noBorder
}: AssessmentFieldProps) => {
    const { t } = useTranslate();

    const cachedData = getMcpParameterDetails(mcpId);

    return (
        <Grid container alignItems="center" justifyContent="flex-start">
            <Grid
                md={6}
                xs={6}
                sx={{
                    borderBottom: noBorder ? 'none' : '1px solid #E0E0E0',
                    minHeight: "45px",
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                    {t(label)}
                </ByzMuiTypography>
            </Grid>
            <Grid
                md={6}
                xs={6}
                sx={{
                    minHeight: "45px",
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <ByzMcParameterDetailSelect
                    sx={{ width: "300px !important", marginLeft: "10px" }}
                    title={t("select")}
                    mcpId={mcpId}
                    value={value}
                    multiple={false}
                    handleChange={(val) => {
                        if (val && !Array.isArray(val)) {
                            onChange(val as McParameterDetailResponseDto);
                        } else {
                            onChange(null);
                        }
                    }}
                    cachedData={cachedData}
                    cacheLoaded={cacheLoaded}
                />
            </Grid>
        </Grid>
    );
};
